<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            :vo-name="isEdit ? 'ProductCouponGetVo' : 'ProductCouponAddVo'"
            :data="tmpProductCoupon" 
            @changed="onFormChange"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateProductCoupon"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateProductCouponLoading"
          />
          <template v-if="isEdit">
            &nbsp;
            <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
          </template>
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
    <CModal
      :show.sync="showDeleteModal"
      :centered="true"
      color="default"
    >
      {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{productCoupon.name}}</b>
      <br/><br/>
      <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== productCoupon.name"
          @click="onDeleteProductCoupon"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deleteProductCouponLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'ProductCoupon',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpProductCoupon: {},
      updateProductCouponLoading: false,
      deleteProductCouponLoading: false,
      appFormKey: generateGUID(),
      showSectionEditor: false,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      productCoupon: state => state.product.productCoupon,
    }),
  },
  methods: {
    ...mapActions({
      getProductCoupon: 'product/getProductCoupon',
      updateProductCoupon: 'product/updateProductCoupon',
      addProductCoupon: 'product/addProductCoupon',
      deleteProductCoupon: 'product/deleteProductCoupon',
    }),
    ...mapMutations({
      setProductCoupon: 'product/setProductCoupon',
    }),
    goBack() {
      this.$router.push({path: '/product-coupon'})
    },
    onFormChange (data) {
      this.tmpProductCoupon = {...data}
    },
    onAddOrUpdateProductCoupon () {
      if (this.tmpProductCoupon.id) {
        this.updateProductCouponLoading = true
        this.updateProductCoupon(this.tmpProductCoupon)
          .then(() => {
            this.updateProductCouponLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateProductCouponLoading = false
          })
      } else {
        this.updateProductCouponLoading = true
        this.addProductCoupon(this.tmpProductCoupon)
          .then(() => {
            this.updateProductCouponLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateProductCouponLoading = false
          })
      }
    },
    onDeleteProductCoupon () {
      this.deleteProductCouponLoading = true
      this.deleteProductCoupon(this.productCoupon.id)
          .then(() => {
            this.deleteProductCouponLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteProductCouponLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getProductCoupon(this.$route.params.id).then(() => {
        this.tmpProductCoupon = this.productCoupon
      })
    }
  },
  destroyed() {
    this.setProductCoupon({})
  }
}
</script>

<style>
  .section-modal.overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(51,51,51,0.7);
    z-index: 10;
  }

  .section-modal > .modal-header {
    padding: 5px;
  }

  .section-modal > .modal-content {
    overflow: hidden;
  }

  .section-modal > .modal-body {
    overflow-y: scroll;
    padding: 0px;
  }

  .section-modal > .modal-footer {
    display: none;
  }
</style>